<script setup lang="ts">
import { useToast } from "../../composables/useToast";
import { CheckCircle2, XCircle, Info, X } from "lucide-vue-next";
import { computed } from "vue";

const { state, dismiss } = useToast();
const items = computed(() => state.toasts);

const iconFor = (kind: string) => {
  if (kind === "success") return CheckCircle2;
  if (kind === "error")   return XCircle;
  return Info;
};
const classFor = (kind: string) => {
  if (kind === "success") return "border-success-500/30 bg-surface-0 text-success-600";
  if (kind === "error")   return "border-danger-500/30  bg-surface-0 text-danger-600";
  return "border-info-500/30 bg-surface-0 text-info-600";
};
</script>

<template>
  <Teleport to="body">
    <div class="fixed bottom-6 right-6 z-[1000] flex flex-col gap-2 max-w-sm">
      <transition-group name="toast" tag="div" class="flex flex-col gap-2">
        <div
          v-for="t in items"
          :key="t.id"
          :class="['flex items-start gap-3 rounded-lg border shadow-elevated px-4 py-3 text-sm', classFor(t.kind)]"
          role="status"
        >
          <component :is="iconFor(t.kind)" class="size-5 shrink-0 mt-0.5" />
          <div class="flex-1 text-surface-900">
            {{ t.message }}
            <router-link
              v-if="t.action"
              :to="t.action.to"
              class="block mt-1 font-medium text-accent-600 hover:text-accent-700"
              @click="dismiss(t.id)"
            >{{ t.action.label }} →</router-link>
          </div>
          <button
            class="text-surface-400 hover:text-surface-700 shrink-0"
            :aria-label="'Закрыть'"
            @click="dismiss(t.id)"
          >
            <X class="size-4" />
          </button>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active { transition: all 200ms ease; }
.toast-enter-from   { opacity: 0; transform: translateY(8px); }
.toast-leave-to     { opacity: 0; transform: translateY(-8px); }
</style>
